/* eslint-disable react/no-unknown-property */
import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_20552_51462)">
      <path
        d="M0.832031 3.33325V8.33325H5.83203"
        stroke="#010032"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.168 16.6668V11.6667H14.168"
        stroke="#010032"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0737 7.49998C16.6511 6.30564 15.9328 5.23782 14.9858 4.39616C14.0389 3.55451 12.8941 2.96645 11.6585 2.68686C10.4228 2.40727 9.1364 2.44527 7.91937 2.79729C6.70234 3.14932 5.59432 3.80391 4.6987 4.69998L0.832031 8.33332M19.1654 11.6666L15.2987 15.3C14.4031 16.1961 13.2951 16.8506 12.078 17.2027C10.861 17.5547 9.57462 17.5927 8.33894 17.3131C7.10325 17.0335 5.95853 16.4455 5.01159 15.6038C4.06464 14.7621 3.34634 13.6943 2.9237 12.5"
        stroke="#374151"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_20552_51462">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const RefreshIcon2 = (props) => <Icon component={svg} {...props} />;

export default RefreshIcon2;
